import {Metadata} from "next";

const isDev = process.env.NEXT_PUBLIC_APP_ENV === 'dev';

export const SITE_TITLE = "Aldex Win – Top Slots, Live Games & Fast Payouts";

export const SITE_METADATA: Metadata = {
    icons: {
        icon: isDev ? '/favicon-dev.ico' : '/favicon-prod.ico',
    },
    // Keep the dev environment out of search engines. Allows crawling so Google
    // can see the noindex and drop already-indexed alddev.xyz URLs.
    robots: isDev
        ? {index: false, follow: false, nocache: true, googleBot: {index: false, follow: false}}
        : undefined,
    title: SITE_TITLE,
    description: "Discover Aldex Online Casino with a wide selection of slots, live dealer games and fast, secure payments. Enjoy a reliable gaming platform, responsible play features and 24/7 support.",
};
